module.exports = __webpack_public_path__ + "static/media/money-bg.46c45404.jpg";